var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog',{class:['popup', _vm.modal && 'popup-modal'],attrs:{"open":_vm.isOpen},on:{"click":_vm.handleClick}},[_c('section',{staticClass:"popup-inner"},[_c('article',{staticClass:"popup-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }